var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgMore = function SvgMore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "more_svg__\\u56FE\\u5C42_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4,24c-2.21,0-4-1.79-4-4s1.79-4,4-4s4,1.79,4,4S6.21,24,4,24z M20,24c-2.21,0-4-1.79-4-4s1.79-4,4-4 s4,1.79,4,4S22.21,24,20,24z M36,24c-2.21,0-4-1.79-4-4s1.79-4,4-4s4,1.79,4,4S38.21,24,36,24z",
    fillRule: "evenodd",
    clipRule: "evenodd"
  })));
};
export default SvgMore;